import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Grid, Cell, Section } from 'formlabs-web-components/Grid';
import classNames from 'classnames';
import useIsMobile from '../../../hooks/useIsMobile';

import './AlignmentWrapper.module.css';

const AlignmentWrapper = ({
  alignment,
  width = '24',
  margin = 0,
  itemsPerRow = 0,
  pin = false,
  children
}) => {
  const sectionId = uuidv4();
  const offset = (24 - width) / 2;
  const mobile = useIsMobile(640);
  const tablet = useIsMobile(1000);
  const layout = itemsPerRow < 2 ? 'block' : 'grid';
  const mobileItems = itemsPerRow < 7 ? '1' : '2';
  const tabletItems = itemsPerRow < 7 ? '2' : '4';

  const items = mobile ? mobileItems : tablet ? tabletItems : itemsPerRow;

  if (children) {
    return (
      <Section
        padding={`${margin}rem 0rem`}
        paddingMedium={`${margin}rem 0rem`}
        paddingSmall={`${margin / 2}rem 0rem`}
        classes={classNames('alignment-wrapper', { pin })}
        id={sectionId}
      >
        <Grid direction="x" gutters="margin">
          <Cell
            smallOffset="0"
            mediumOffset={offset}
            largeOffset={offset}
            largeSize={width}
            mediumSize={width}
            smallSize="24"
            styles={{
              display: layout,
              textAlign: alignment,
              gridTemplateColumns: `repeat(${items}, 1fr)`,
              rowGap: '.5rem'
            }}
          >
            {children.length > 1
              ? children.map((child, i) => (
                  <span styleName="content" key={i}>
                    {child}
                  </span>
                ))
              : children[0] || null}
          </Cell>
        </Grid>
      </Section>
    );
  }
  return null;
};

export default AlignmentWrapper;
